import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Divider from '@mui/material/Divider';
import Alert from '@mui/material/Alert';

import config from '../../../config';
import { VpButton, PromoCodeInputs } from '../..';

import { PLAN_TYPE } from '../../../constants/index';
import { useFetchFreeTrialPeriod } from '../../../hooks/react-query/useFeatureData';
import { getDateData } from '../../../utils/date-utils';

export const VpStripePlanInfoAlert = ({
  plan = {},
  onApplyCode = null,
  disablePromoCode = false
}) => {
  const [isShowingPromo, setIsShowingPromo] = useState();
  const { data: freeTrialPeriod } = useFetchFreeTrialPeriod();

  const onShowPromoInputs = () => {
    setIsShowingPromo(true);
  };

  const action = (
    <VpButton
      sx={{
        color: 'vpColors.blueDarker'
      }}
      onClick={onShowPromoInputs}
    >
      promo code
    </VpButton>
  );

  const freeBillingDate = getDateData({ inDays: freeTrialPeriod });

  const billingLabel =
    plan?.planKey === PLAN_TYPE['free-trial']
      ? `billing cycle starting ${freeBillingDate}`
      : 'billed today';

  return (
    <>
      <Alert
        sx={{
          borderRadius: '6px 6px 0 0',
          mb: '5px'
        }}
        icon={false}
        severity="info"
        action={config?.promoCodeEnabled && !isShowingPromo && !disablePromoCode ? action : null}
      >
        {plan?.label}
      </Alert>
      <Alert
        sx={{
          borderRadius: '0 0 6px 6px',
          mb: '20px'
        }}
        icon={false}
        severity="info"
      >
        {`$${plan?.amount}`} / {plan?.frequency}, {billingLabel}
      </Alert>
      {isShowingPromo && <PromoCodeInputs plan={plan} onApplyCode={onApplyCode} />}
      <Divider
        sx={{
          mb: '20px'
        }}
      />
    </>
  );
};

VpStripePlanInfoAlert.propTypes = {
  plan: PropTypes.object,
  onApplyCode: PropTypes.func,
  disablePromoCode: PropTypes.bool
};

export default VpStripePlanInfoAlert;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/Stripe/VpStripePlanInfoAlert.jsx